/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Refresh_BtnInputs */

const tr_geliver_tracking_refresh_btn = /** @type {(inputs: Geliver_Tracking_Refresh_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenile`)
};

const en_geliver_tracking_refresh_btn = /** @type {(inputs: Geliver_Tracking_Refresh_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

const de_geliver_tracking_refresh_btn = /** @type {(inputs: Geliver_Tracking_Refresh_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisieren`)
};

const ru_geliver_tracking_refresh_btn = /** @type {(inputs: Geliver_Tracking_Refresh_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Geliver_Tracking_Refresh_BtnInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_refresh_btn = /** @type {((inputs?: Geliver_Tracking_Refresh_BtnInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Refresh_BtnInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_refresh_btn(inputs)
	if (locale === "de") return de_geliver_tracking_refresh_btn(inputs)
	if (locale === "ru") return ru_geliver_tracking_refresh_btn(inputs)
	return tr_geliver_tracking_refresh_btn(inputs)
});